module.exports = __webpack_public_path__ + "img/3.1.484762f0.png";